import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { Fee } from "../utils/types/agencyFee";

export const fetchAgencyFeeList = async () => {
  const response = await axiosServices.get("/agencyfee");
  const resData = await response.data;
  return convertToCamelCase<Fee[]>(resData.data);
};

export const updateAgencyFeeListData = async (
  id: string,
  data: {
    [key: string]: any;
    agencyFeeId: string;
  }
) => {
  let inputData;
  if (data.PXPAbbr) {
    inputData = {
      PXP_abbr: data.PXPAbbr,
      port_callings_id: data.portCallingsId,
    };
  } else inputData = convertToSnakeCase(data);
  await axiosServices.put(`/agencyfee/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deleteAgencyFeeListData = async (id: string) => {
  const response = await axiosServices.delete(`/agencyfee/${id}`);
  return { success: response.data.success, id };
};

export const addAgencyFeeListData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/agencyfee`, inputData);
  return convertToCamelCase<Fee>(response.data.data);
};
